import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_GET_CAMPAIGN_CUSTOMERS, API_GET_CAMPAIGNS , API_GET_CAMPAIGN_ANALYTICS } from "../api/dashboard.service";
const initialState = {
  loading:false,
  campaigns: [],
  selectedCampaignId:"all",
  totalCampignsCount:0,
  totalCampaignCustomersCount:0,
  campaignCustomers:[],
  selectedCampaign:{id:"all", campaignName:"All Campaigns"},
  campCustomerPage:0,
  page: 0,
  limit: 10,
  stats:[],
  mode:null,
};
export const getCampaignsAnalytics = createAsyncThunk(
  "dashboard/getCampaignAnalytics",
  async ({id}, thunkAPI) => {
    try {
      const data = await API_GET_CAMPAIGN_ANALYTICS(id);
    
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const getAllCampaigns = createAsyncThunk(
  "dashboard/getCampaignList",
  async ({page,limit}, thunkAPI) => {
    try {
      const data = await API_GET_CAMPAIGNS(page,limit);
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const getCampaignCustomers = createAsyncThunk(
    "dashboard/getCampaignCustomers",
    async ({id,page,limit,status},thunkAPI) => {
      try {
        const data = await API_GET_CAMPAIGN_CUSTOMERS(id,page,limit,status);
        return data;
      } catch (err) {
        return thunkAPI.rejectWithValue(err.response.data)
      }
    }
  );

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    changePage(state, action) {
      state.page = action.payload
    },
    changecampCustomerPage(state, action){
      state.campCustomerPage = action.payload
    },
    changeSelectedCampaignId(state, action){
      if(action.payload !== "all"){
       const  campDetails = state.campaigns.filter(camp => camp.id === action.payload);  
        state.selectedCampaign = campDetails[0];
      }else{
        state.selectedCampaign = {id:"all", campaignName:"All Campaigns"}
      }
      state.selectedCampaignId = action.payload
    },
    changeSelectedCampaign(state,action){
      state.selectedCampaignId = action.payload.id;
      state.selectedCampaign = action.payload
    },
    clearCampaignCustomers(state){
      state.campaignCustomers = [];
    },
    resetSelectedCampaign(state){
      state.selectedCampaignId = "all";
      state.selectedCampaign = {id:"all", campaignName:"All Campaigns"}
    },
    changeCampMode(state, action){
      state.mode = action.payload
    },
    resetCampMode(state){
      state.mode = null
    }

  },

  extraReducers: (builder) => {

    builder.addCase(getAllCampaigns.fulfilled, (state, action) => {
        state.loading=false;
        state.totalCampignsCount = action.payload.count;
        state.campaigns = action.payload.rows;
        //state.selectedCampaignId = action.payload[0].id;
    });
    builder.addCase(getAllCampaigns.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllCampaigns.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getCampaignCustomers.fulfilled, (state, action) => {
        state.loading=false
        state.campaignCustomers = action.payload.customers
        state.totalCampaignCustomersCount = action.payload.count;
    });
    builder.addCase(getCampaignCustomers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCampaignCustomers.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getCampaignsAnalytics.fulfilled, (state, action) => {
         state.loading=false
         state.stats = action.payload
     });
     builder.addCase(getCampaignsAnalytics.pending, (state) => {
       state.loading = true;
     });
     builder.addCase(getCampaignsAnalytics.rejected, (state) => {
       state.loading = false;
     });

  },
});

export const {
  changeSelectedCampaign,
  changePage,
  clearCampaignCustomers,
  changecampCustomerPage,
  changeSelectedCampaignId,
  resetSelectedCampaign,
  changeCampMode,
  resetCampMode,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
